import React, { Component } from 'react'

export default class InputCounter extends Component {
    render() {
        const { containerStyle = {}, inputStyle = {}, 
            onAdd, onReduce, onChange, value = "", 
            placeholder = "", center = false,
        } = this.props;

        var holderStyle = {...styles.inputHolder, ...containerStyle};
        center && (holderStyle.justifyContent = "center");

        var wrapperStyle = {...styles.inputWrapper};
        center && (wrapperStyle.justifyContent = "center");

        return (
            <div style={holderStyle}>
                <div style={wrapperStyle}>
                    <i 
                        style={{...styles.inputBtn, ...styles.inputBtnLeft}} 
                        className="fas fa-minus" 
                        onClick={() => onReduce && onReduce()}></i>
                    <input 
                        style={{...styles.input, ...inputStyle}}
                        value={value}
                        onChange={(e) => onChange && onChange(e)} 
                        placeholder={placeholder} />
                    <i 
                        style={{...styles.inputBtn, ...styles.inputBtnRight}} 
                        className="fas fa-plus" 
                        onClick={() => onAdd && onAdd()}></i>
                </div>
            </div>
        )
    }
}

const styles = {
    inputHolder: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",
        margin: "2.5px",
    },
    inputWrapper: {
        display: "flex",
        flexDirection: "row",
        alignItems: "strech",
        justifyContent: "flex-end",
        margin: "2.5px",
        width: "10%",
        color: "#666",
    },
    input: {
        border: "2.5px solid #666",
        padding: "5px",
        fontSize: "1.0rem",
        textAlign: "center",
        maxWidth: "85px",
    },
    inputBtn: {
        margin: "auto 2.5px",
        padding: "5px",
        fontSize: "1.15rem",
        border: "2.5px solid #666",
        borderRadius: ".5rem",
    },
    inputBtnLeft: {
        borderRadius: ".5rem 0 0 .5rem"
    },
    inputBtnRight: {
        borderRadius: "0 .5rem .5rem 0"
    }
}
